// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Alert, Action, uniqueId } from '@op/opds.opux';
import message from '../messages';

export interface ErrorItem {
    id: string;
    message: string;
    index?: number;
    isAdminError?: boolean;
}

interface InputErrorTileProps {
    errors: ErrorItem[];
}

const InputErrorTile: React.FC<InputErrorTileProps> = ({ errors }) => {
    const handleNavLinkClick = (event: Event, item: ErrorItem): void => {
        event?.preventDefault();

        const elements = item.isAdminError
            ? document.getElementsByClassName(item.id)
            : [document.getElementById(item.id)];
        const element = elements[item.index ?? 0] as HTMLElement;

        if (element) {
            element.focus({ preventScroll: true });

            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };

    if (errors?.length === 0) return null;

    return (
        <Alert
            type="critical"
            title={message('notificationErrorHeader')}
            data-testid="alert"
            role="alert"
            aria-live="polite"
        >
            <ol>
                {errors.map((item) => (
                    <li key={uniqueId()} data-testid="errorlist">
                        <Action
                            href="#"
                            onClick={(e: any) => handleNavLinkClick(e, item)}
                            data-testid={item.message}
                            aria-label={`${message('notificationErrorHeader')}: ${item.message}`}
                        >
                            {item.message}
                        </Action>
                    </li>
                ))}
            </ol>
        </Alert>
    );
};

export default InputErrorTile;
